@if (visible || loading) {
    <h3 class="m-0 mb-2 px-1 text-lg font-bold">{{ title }}</h3>

    <app-card [noMargin]="true" [showHeader]="false">
        <div card-body class="pipeline-body">
            @if (loading) {
                <app-loading-indicator></app-loading-indicator>
            } @else {
                <!--
                  Left to right is the order work moves, so a column filling up
                  beside an empty one to its right is the shape of a backlog.
                -->
                <div class="columns">
                    @for (column of columns; track column.stage) {
                        <section class="column">
                            <div class="column-head">
                                <span class="column-label">{{ column.label }}</span>
                                @if (!column.locked) {
                                    <span class="column-count">{{ column.count }}</span>
                                }
                            </div>

                            @if (column.composition && !column.locked) {
                                <p class="column-composition" [title]="column.composition">
                                    {{ column.composition }}
                                </p>
                            }

                            @if (column.locked) {
                                <!--
                                  Nothing in this stage is on the plan, so the
                                  column says which plan would fill it rather
                                  than reporting that nothing has happened.
                                -->
                                <div class="column-locked">
                                    <img
                                        class="column-locked__art"
                                        src="/assets/img/illustration_upgrade-icon.svg"
                                        alt="" />
                                    @if (column.unlockedBy) {
                                        <span class="column-plan">{{ column.unlockedBy }}</span>
                                    }
                                    <p class="column-locked__note">{{ upgradeLabel }}</p>
                                </div>
                            } @else if (column.count) {
                                <!--
                                  The age is the signal the panel exists for:
                                  twenty-four items is fine if the oldest is
                                  three days and a problem if it is thirty-four.
                                -->
                                <p class="column-age">Oldest {{ column.ageLabel }}</p>

                                <ul class="cards">
                                    @for (card of column.cards; track card.id) {
                                        <li class="card">
                                            <a
                                                class="card-link"
                                                [class.overdue]="card.overdue"
                                                [routerLink]="card.routerLink">
                                                @if (card.overdue) {
                                                    <!--
                                                      The record needing
                                                      attention is marked, not
                                                      the column it sits in.
                                                    -->
                                                    <i
                                                        class="pi pi-exclamation-circle card-alert"
                                                        aria-hidden="true"></i>
                                                }
                                                <span class="card-text">
                                                    <span class="card-title">{{ card.title }}</span>
                                                    <span class="card-meta">
                                                        @if (card.reference) {
                                                            <span>{{ card.reference }}</span>
                                                        }
                                                        <span>{{ card.ageLabel }}</span>
                                                    </span>
                                                </span>
                                            </a>
                                        </li>
                                    }
                                </ul>

                                @if (column.remaining) {
                                    <a
                                        class="column-more"
                                        [routerLink]="['/pipeline', column.stage]">
                                        +{{ column.remaining }} more
                                    </a>
                                }
                            } @else {
                                <p class="column-empty">{{ emptyLabel }}</p>
                            }
                        </section>
                    }
                </div>
            }
        </div>
    </app-card>
}
